import { Timer } from '@p2p/entities/payment';
import { TGetOrderResponse } from '@p2p/services';

import { isPayViaLinkOrder } from '../../PayByLink/payByLink.utils';
import { DeepLinkActionPay } from '../DeepLinkActionPay';
import { FailModal } from '../FailModal';
import { SuccessModal } from '../SuccessModal';
import { TBankInfoBlock } from '../TBankInfoBlock';
import { useDeepLink } from '../useDeepLink';
import styles from './DeepLinkMobile.module.scss';
import { DeepLinkMobileDescription } from './DeepLinkMobileDescription';

type DeepLinkMobileProps = {
  order: TGetOrderResponse;
  onSuccess: () => void;
};

export const DeepLinkMobile = ({ order, onSuccess }: DeepLinkMobileProps) => {
  const { show, isFail, isTinkoff } = useDeepLink({ order });

  return (
    <>
      {/* P2P-2890: у заявок с оплатой по ссылке провайдера (PayByLink) банковский
          диплинк не показываем — см. isPayViaLinkOrder. */}
      {show && !isFail && !isPayViaLinkOrder(order) && (
        <section className={styles.container}>
          <header className={styles.headerWrapper}>
            <h3 className={styles.header}>Быстрая оплата</h3>
            <Timer time={order.time_left} />
          </header>
          <DeepLinkMobileDescription order={order} />
          {isTinkoff && (
            <TBankInfoBlock
              bankName={order.requisite.bank.name}
              bankLogoSrc={order.bank_svg_image || ''}
              fio={order.requisite.fio || ''}
            />
          )}
          <DeepLinkActionPay />
        </section>
      )}

      <SuccessModal onSuccess={onSuccess} />
      <FailModal order={order} />
    </>
  );
};
